import { shopifyCopy } from '@discovr/features/copy';

// SHOPIFY_VIEWS is the single source of truth for this tab's `?sub` values —
// mirrors CAMPAIGN_SETTINGS_SUBS/CampaignSettingsSub in search.ts (same
// pattern: a plain string search param validated against this list, not a
// separate enum the schema doesn't know about). Kept local rather than
// hoisted into search.ts since (unlike Settings' subs) only this tab reads
// it — see isShopifyView below.
//
// "settings" here is Shopify's OWN store-connection/API sub-view — distinct
// from, and unrelated to, the campaign-level Settings TAB (?tab=settings).
// It has no share-link virtual slug (share_link_handler.go's
// shareLinkVirtualSubTabs) and must never get one: DashboardLayout.tsx's
// getShareInput() blocks minting a link for it explicitly. "coupons" is the
// one Shopify sub-view a public share link can ever point at.
export const SHOPIFY_VIEWS = ['coupons', 'settings'] as const;
export type ShopifyView = (typeof SHOPIFY_VIEWS)[number];
export const isShopifyView = (value: string | undefined): value is ShopifyView =>
  value !== undefined && (SHOPIFY_VIEWS as readonly string[]).includes(value);

export const VIEW_TABS: ReadonlyArray<{ key: ShopifyView; label: string }> = [
  { key: 'coupons', label: 'Coupons' },
  { key: 'settings', label: shopifyCopy.settingsTab.label },
];

/** Campaign-page search params for the Shopify Coupons tab and the Conversions report. */
export const SHOPIFY_COUPONS_SEARCH = { tab: 'shopify', sub: 'coupons' } as const;
export const SHOPIFY_SALES_SEARCH = { tab: 'reporting', sub: 'conversions' } as const;
